import { useState, useRef } from "react";
import { GUIDE_SECTIONS } from "./guidesData";

export default function GuidesTab() {
  const [openItems,     setOpenItems]     = useState<Record<string, boolean>>({});
  const [activeSection, setActiveSection] = useState(GUIDE_SECTIONS[0].id);
  const sectionRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const toggle = (key: string) =>
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));

  const scrollTo = (id: string) =>
    sectionRefs.current[id]?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <div className="sh-layout">

      {/* Left nav */}
      <div className="sh-nav-card">
        <div className="sh-nav__label">Sections</div>
        <div className="sh-nav__list">
          {GUIDE_SECTIONS.map((s) => (
            <button
              key={s.id}
              className={`sh-nav__btn ${activeSection === s.id ? "sh-nav__btn--active" : ""}`}
              onClick={() => { setActiveSection(s.id); scrollTo(s.id); }}
            >
              <span>{s.title}</span>
              <span className="sh-nav__count">{s.items.length}</span>
            </button>
          ))}
        </div>
        <div className="sh-nav__tip">
          <i className="fas fa-lightbulb" />
          {" "}Step-by-step guidance for each part of the platform.
        </div>
      </div>

      {/* Main content */}
      <div className="sh-main">
        {GUIDE_SECTIONS.map((section) => (
          <div
            key={section.id}
            className="sh-section-card"
            ref={(el) => { sectionRefs.current[section.id] = el; }}
          >
            <div className="sh-section-card__head">
              <span className="sh-section-card__title">{section.title}</span>
              <span className="sh-section-card__count">{section.items.length} guides</span>
            </div>
            <div className="sh-accordion">
              {section.items.map((item, idx) => {
                const key  = `${section.id}:${idx}`;
                const open = !!openItems[key];
                return (
                  <div key={key} className={`sh-accordion__item ${open ? "sh-accordion__item--open" : ""}`}>
                    <button className="sh-accordion__trigger" onClick={() => toggle(key)}>
                      <div className="sh-accordion__trigger-left">
                        <span className="sh-accordion__icon-box">
                          <i className="fas fa-book-open" />
                        </span>
                        <span className="sh-accordion__question">{item.heading}</span>
                      </div>
                      <i className={`fas ${open ? "fa-chevron-up" : "fa-chevron-down"} sh-accordion__chevron`} />
                    </button>
                    {open && (
                      <div className="sh-accordion__answer">
                        <p>{item.body}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
